const regularBillingHistory = state => state.history
const regularBillingAllatkey = state => state.allatkey
const status = state => state.status

export default {
    regularBillingHistory,
    regularBillingAllatkey,
    status
}
